import { convertOrderData } from "../../QuotesAndOrdersDynamicPage";

const { default: apiClient } = require("lib/api-client");

// Left Side
export const fetchAllOrders = async ({ queryKey }) => {
  const [, clientId] = queryKey;

  const res = await apiClient.post(`/api/v9/myBinnys/getClientAllOrderSummary`, { clientCode: clientId });

  return res.data?.data?.orderStatusClientData || [];
};

export const fetchStatusWiseOrders = async ({ queryKey }) => {
  const [, clientId, status] = queryKey;

  const res = await apiClient.post(`/api/v9/myBinnys/getClientAllStatusOrderSummary`, { orderStatus: status, clientCode: clientId });

  return res.data?.data?.orderStatusClientData || [];
};

//Right Side

export const fetchAllOrderDesigns = async ({ queryKey }) => {
  const [, orderNos, orderStatus] = queryKey;

  const res = await apiClient.post(`/api/v9/myBinnys/getClientOrderDesigns/all`, { orderNos, orderStatus });

  return convertOrderData(res.data?.data?.orderData);
};

export const fetchSingleOrderDesign = async ({ queryKey }) => {
  const [, orderNo, orderStatus] = queryKey;

  const res = await apiClient.post(`/api/v9/myBinnys/getClientOrderDesigns?orderNo=${orderNo}`, {orderStatus});

  return convertOrderData(res.data?.data?.orderData, true);
};
